export default "__VITE_ASSET__CvFkmbuQ__"